import React from "react";
import { object } from "prop-types";

import { ResponsiveImage } from "@quintype/components";

import "./lightBox.m.css";

const LightBox = ({ element }) => (
  <div styleName="lightbox-wrapper">
    <div styleName="lightbox" className="lightbox">
      <div styleName="image-base">
        <figure className="blank-story-image" styleName="qt-image-16x9">
          <ResponsiveImage
            slug={element["image-s3-key"]}
            aspectRatio={[16, 9]}
            imgParams={{ auto: ["format", "compress"], fmt: "webp" }}
            alt={element["image-attribution"] || ""}
          />
          {element.title && (
            <figcaption styleName="image-caption">
              <div styleName="caption-base">
                <span dangerouslySetInnerHTML={{ __html: element.title }} />
                {element["image-attribution"] && (
                  <span
                    styleName="image-attribute"
                    dangerouslySetInnerHTML={{ __html: `${element["image-attribution"]}` }}
                  />
                )}
              </div>
            </figcaption>
          )}
        </figure>
      </div>
    </div>
  </div>
);

LightBox.propTypes = {
  element: object,
};

export default LightBox;
